/*
 * @Author: caiqin.xie
 * @since: 2023-08-24 16:13:13
 * @lastTime: 2023-11-10 17:13:13
 * @LastEditors: caiqin.xie
 * @message: 配件
 * @url: www.picoxr.com/cn/accessory
 */
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import AccessorySlider from "./components/AccessorySlider";
import request from '@/common/request'
import { DOMAIN_API, COUNTRY_HREFLANG, COUNTRY_LIST } from '@/common/const'
import styles from "./index.module.scss";
import classNames from "classnames";

interface IAccessory {
  id: string; // 配件id
  name: string; // 配件名称
  briefIntroduction: string; // 配件简介
  detail: string; // 配件详情
  images: Record<string, any>[]; // 配件图片列表
  [key: string]: any;
}

const AccessoryDetail = (props: any) => {
  const {ctry, words, data} = props.data
  const detail: IAccessory = data || {} // 配件详情
  const images = detail.images || [] // 配件图片

  // 渲染详情
  const creatHtml = () => {
    return {__html: detail?.detail}
  }

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/accessory/${detail?.id}`} />
      ))
    )
  }

  return (
    <div>
      <Helmet>
        <title>{words?.spare_part_seo_titile}</title>
        <meta name="description" content={words?.spare_part_seo_description} />
        <meta name="keywords" content={words?.spare_part_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/accessory/${detail?.id}`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['spare-wrap']}>
        <div className={styles['content-wrap']}>
          <AccessorySlider images={images} />
          <div className={styles['spare-content-wrap']}>
            <h1 className={styles['spare-title']}>{detail?.name}</h1>
            <div className={styles['spare-desc']}>{detail?.briefIntroduction}</div>
            <div className={classNames(styles['spare-content'], 'editor-wrap')}  dangerouslySetInnerHTML={creatHtml()}></div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit (ctry: string, pathName: string) {
  return new Promise((resolve, reject) => {
    const id = pathName.split('?')[0].split('/').pop();
    request.post(`${DOMAIN_API}/o/accessory/getDetail`, {
      id
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

AccessoryDetail.getInitialProps = (ctry: string, pathName: string) => {
  return getInit(ctry, pathName)
};
export default AccessoryDetail;
